import React from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Modal = ({isOpen, onClose, title, children}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            onClick={onClose}
            className="absolute inset-0 bg-black/50"
            style={{backdropFilter: 'blur(8px)'}}
          />
          
          <motion.div
            initial={{scale: 0.9, opacity: 0, y: 20}}
            animate={{scale: 1, opacity: 1, y: 0}}
            exit={{scale: 0.9, opacity: 0, y: 20}}
            className="bg-white w-full max-w-md rounded-3xl shadow-2xl p-6 relative z-10 max-h-[85vh] overflow-y-auto scrollbar-hide"
            style={{
              WebkitFontSmoothing: 'antialiased',
              MozOsxFontSmoothing: 'grayscale',
              textRendering: 'optimizeLegibility',
              fontSmooth: 'always',
              backfaceVisibility: 'hidden',
              transform: 'translateZ(0)'
            }}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 bg-gray-100 hover:bg-gray-200 rounded-full p-2.5 transition-colors z-10 shadow-sm"
            >
              <SafeIcon icon={FiIcons.FiX} className="text-gray-700 text-lg" />
            </button>

            <h2 className="text-2xl font-black text-center text-[#ff7e5f] mb-6 drop-shadow-sm">
              {title}
            </h2>

            {children}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Modal;